// Collection complète de parfums Azynti - Nouvelle sélection exclusive
export const perfumes = [
  {
    id: 1,
    name: "A LA ROSE",
    category: "Floral",
    description: "L'essence noble de la rose de Mai dans sa splendeur absolue, rehaussée par la fraîcheur du pamplemousse et la profondeur boisée.",
    notes: ["Rose de Mai", "Pamplemousse", "Amber Wood", "Sauge"],
    personality: ["élégant", "sophistiqué", "romantique", "noble"],
    mood: ["romantique", "confiant", "raffiné"]
  },
  {
    id: 2,
    name: "AL IKSIR",
    category: "Oriental",
    description: "Un élixir mystique où la muscade épicée danse avec la cannelle et la lavande, sublimé par l'ambre et la réglisse.",
    notes: ["Muscade", "Cannelle", "Lavande", "Réglisse", "Ambre"],
    personality: ["mystique", "épicé", "chaleureux", "envoûtant"],
    mood: ["mystérieux", "confiant", "sophistiqué"]
  },
  {
    id: 3,
    name: "AMBER NIGHT",
    category: "Ambre",
    description: "La nuit ambrée dans toute sa magnificence, où les baies roses rencontrent la bergamote et l'ambre gris.",
    notes: ["Baies Rose", "Bergamote", "Rose", "Ambre Gris", "Cèdre", "Bois de Gaiac"],
    personality: ["nocturne", "sophistiqué", "luxueux", "mystérieux"],
    mood: ["mystérieux", "sensuel", "élégant"]
  },
  {
    id: 4,
    name: "ANGEL SHARK",
    category: "Gourmand",
    description: "Un requin angélique dans cette composition gourmande où le cognac rencontre la vanille et l'amande.",
    notes: ["Cognac", "Cannelle", "Tonka", "Vanille", "Amande"],
    personality: ["gourmand", "puissant", "séduisant", "chaleureux"],
    mood: ["confiant", "séduisant", "chaleureux"]
  },
  {
    id: 5,
    name: "AYSHA",
    category: "Floral Oriental",
    description: "Un hommage oriental où la bergamote citronné se marie à la fleur d'oranger et à la vanille douce.",
    notes: ["Bergamote", "Citron", "Patchouli", "Absolu Fleur d'Oranger", "Vanille"],
    personality: ["oriental", "floral", "lumineux", "féminin"],
    mood: ["joyeux", "romantique", "énergique"]
  },
  {
    id: 6,
    name: "BACCARAT",
    category: "Luxe",
    description: "Le cristal de Baccarat en parfum, où l'amande amère se mêle au jasmin d'Egypte et à l'ambre gris.",
    notes: ["Amande Amère", "Jasmin d'Egypte", "Ambre Gris", "Notes Boisées"],
    personality: ["luxueux", "précieux", "sophistiqué", "cristallin"],
    mood: ["élégant", "luxueux", "raffiné"]
  },
  {
    id: 7,
    name: "BELUGA",
    category: "Gourmand",
    description: "La délicatesse du caviar Beluga traduite en parfum, avec la tangerine, le patchouli et le daim.",
    notes: ["Tangerine", "Patchouli", "Vanille", "Daim"],
    personality: ["délicat", "luxueux", "fruité", "doux"],
    mood: ["sophistiqué", "confortable", "gourmand"]
  },
  {
    id: 8,
    name: "BISSAP FLOWER",
    category: "Floral Épicé",
    description: "La fleur de bissap dans toute sa splendeur, mélangée à la rose, au cassis et à la cannelle épicée.",
    notes: ["Hibiscus", "Rose", "Cassis", "Ambrette", "Cannelle"],
    personality: ["floral", "épicé", "exotique", "vibrant"],
    mood: ["énergique", "exotique", "joyeux"]
  },
  {
    id: 9,
    name: "BLACK PHANTOM",
    category: "Sombre",
    description: "Un fantôme noir mystérieux, composé de rhum, café et cèdre, avec une pointe de cyanure intrigante.",
    notes: ["Rhum", "Sucre de Canne", "Café", "Cèdre", "Cyanure", "Bois de Santal", "Patchouli"],
    personality: ["mystérieux", "sombre", "intriguant", "puissant"],
    mood: ["mystérieux", "intense", "audacieux"]
  },
  {
    id: 10,
    name: "BLACK SUGAR",
    category: "Gourmand",
    description: "Le sucre noir cristallisé dans cette gourmandise florale à l'orchidée et à la vanille.",
    notes: ["Orchidée", "Sucre", "Vanille"],
    personality: ["gourmand", "sucré", "floral", "simple"],
    mood: ["gourmand", "doux", "réconfortant"]
  },
  {
    id: 11,
    name: "BLACK VANILLA",
    category: "Vanille",
    description: "La vanille noire dans sa version la plus sensuelle, avec le cassis, la pêche blanche et la noix de coco.",
    notes: ["Cassis", "Pêche Blanche", "Noix de Coco Madagascar", "Musc Blanc"],
    personality: ["sensuel", "fruité", "exotique", "doux"],
    mood: ["sensuel", "tropical", "réconfortant"]
  },
  {
    id: 12,
    name: "BOIS",
    category: "Boisé",
    description: "L'essence pure du bois dans cette composition où la muscade rencontre le jasmin et le santal.",
    notes: ["Noix de Muscade", "Baie Rose", "Jasmin", "Cèdre", "Patchouli", "Santal"],
    personality: ["boisé", "naturel", "équilibré", "terreux"],
    mood: ["paisible", "naturel", "ancré"]
  },
  {
    id: 13,
    name: "CALIFORNIA LOVE",
    category: "Fruité",
    description: "L'amour californien dans cette composition ensoleillée aux fèves de tonka et fruits rouges.",
    notes: ["Fèves de Tonka", "Bois de Santal", "Notes Fruits Rouges", "Bergamote", "Framboise"],
    personality: ["ensoleillé", "fruité", "libre", "énergique"],
    mood: ["joyeux", "libre", "optimiste"]
  },
  {
    id: 14,
    name: "CE SOIR",
    category: "Soirée",
    description: "Ce soir sera magique avec cet ambre vanillé aux fèves de tonka et au ciste d'Espagne.",
    notes: ["Ambre", "Vanille", "Fève de Tonka", "Ciste d'Espagne"],
    personality: ["soirée", "élégant", "chaleureux", "séduisant"],
    mood: ["romantique", "élégant", "sensuel"]
  },
  {
    id: 15,
    name: "CHRONIC",
    category: "Épicé",
    description: "Une composition chronique où le poivre danse avec la cannelle, l'ambre et le cuir.",
    notes: ["Poivre", "Cannelle", "Ambre", "Cuir", "Bois de Santal", "Musc Blanc"],
    personality: ["épicé", "cuir", "masculin", "puissant"],
    mood: ["confiant", "puissant", "audacieux"]
  },
  {
    id: 16,
    name: "COCO VANILLA",
    category: "Tropical",
    description: "L'escapade tropicale parfaite avec la noix de coco, la pêche blanche et la vanille de Madagascar.",
    notes: ["Noix de Coco", "Pêche Blanche", "Ylang-Ylang", "Vanille de Madagascar"],
    personality: ["tropical", "ensoleillé", "exotique", "doux"],
    mood: ["tropical", "joyeux", "relaxant"]
  },
  {
    id: 17,
    name: "CRUSH",
    category: "Gourmand",
    description: "Un coup de cœur gourmand où le caramel rencontre le patchouli dans une douceur boisée.",
    notes: ["Caramel", "Patchouli", "Boisé", "Sucré"],
    personality: ["gourmand", "doux", "séduisant", "moderne"],
    mood: ["gourmand", "séduisant", "confortable"]
  },
  {
    id: 18,
    name: "DELIGHT",
    category: "Floral Gourmand",
    description: "Un délice floral où la pivoine danse avec les dates, le miel et la vanille.",
    notes: ["Pivoine", "Dates", "Coumarine", "Caramel", "Fève Tonka", "Miel", "Vanille"],
    personality: ["délicieux", "floral", "gourmand", "complexe"],
    mood: ["joyeux", "gourmand", "sophistiqué"]
  },
  {
    id: 19,
    name: "DIORAMA",
    category: "Oriental",
    description: "Un diorama olfactif où l'orange rencontre le rhum, le cacao et la vanille bourbon.",
    notes: ["Orange", "Poivre Rose", "Rhum", "Cacao", "Vanille Bourbon", "Bois de Santal"],
    personality: ["oriental", "gourmand", "épicé", "chaleureux"],
    mood: ["chaleureux", "gourmand", "sophistiqué"]
  },
  {
    id: 20,
    name: "DOUBLE HONEY",
    category: "Miel",
    description: "Le double miel dans cette composition où le clou de girofle rencontre le tabac et la vanille.",
    notes: ["Miel", "Clou de Girofle", "Tabac", "Vanille", "Bois de Santal"],
    personality: ["miel", "chaleureux", "épicé", "réconfortant"],
    mood: ["chaleureux", "réconfortant", "gourmand"]
  },
  {
    id: 21,
    name: "DREAM OUD",
    category: "Oud",
    description: "Le rêve d'oud dans cette composition où les bois précieux rencontrent le praliné et le safran.",
    notes: ["Bois de Oud", "Bois de Gaiac", "Praliné", "Bois de Copahu", "Vanille", "Safran", "Oud"],
    personality: ["oud", "rêveur", "précieux", "mystique"],
    mood: ["mystérieux", "luxueux", "rêveur"]
  },
  {
    id: 22,
    name: "EL OUASSINIA",
    category: "Fruité",
    description: "El Ouassinia, où la pêche rencontre le café dans une harmonie sucrée et musquée.",
    notes: ["Pêche", "Café", "Bois de Santal", "Musc Blanc", "Caramel"],
    personality: ["fruité", "énergique", "doux", "moderne"],
    mood: ["énergique", "gourmand", "réconfortant"]
  },
  {
    id: 23,
    name: "ERBA",
    category: "Frais",
    description: "L'herbe fraîche dans cette composition d'agrumes où l'orange, la bergamote et le citron dansent.",
    notes: ["Orange", "Bergamote", "Citron", "Fruits Exotique", "Musc Blanc"],
    personality: ["frais", "agrumes", "énergique", "naturel"],
    mood: ["énergique", "frais", "optimiste"]
  },
  {
    id: 24,
    name: "FEVE",
    category: "Aromatique",
    description: "La fève de tonka dans cette composition aromatique où la lavande rencontre la menthe et le jasmin.",
    notes: ["Lavande", "Menthe", "Jasmin", "Fève de Tonka", "Vanille"],
    personality: ["aromatique", "frais", "floral", "équilibré"],
    mood: ["frais", "paisible", "harmonieux"]
  },
  {
    id: 25,
    name: "FRESH ROCK",
    category: "Frais",
    description: "Le rocher frais dans cette composition où la coriandre rencontre le muguet et l'ambroxan.",
    notes: ["Coriandre", "Muguet", "Bois de Santal", "Ambroxan"],
    personality: ["frais", "minéral", "moderne", "propre"],
    mood: ["frais", "énergique", "moderne"]
  },
  {
    id: 26,
    name: "GLAZED",
    category: "Fruité",
    description: "Glacé et fruité, où le citron congelé rencontre la mangue et la crème chantilly.",
    notes: ["Citron Congelé", "Mangue", "Crème Chantilly", "Coco", "Musc Fruité"],
    personality: ["glacé", "fruité", "gourmand", "rafraîchissant"],
    mood: ["rafraîchissant", "gourmand", "joyeux"]
  },
  {
    id: 27,
    name: "GOLD OF OUD",
    category: "Oud",
    description: "L'or de l'oud dans cette composition fruitée où l'ananas rencontre le jasmin et la fève de tonka.",
    notes: ["Notes Fruitées", "Ananas", "Tonka", "Jasmin"],
    personality: ["oud", "fruité", "précieux", "tropical"],
    mood: ["luxueux", "tropical", "joyeux"]
  },
  {
    id: 28,
    name: "GREEN GOLD",
    category: "Vert",
    description: "L'or vert dans cette composition aldéhydée où l'iris rencontre le jasmin sambac et l'amande.",
    notes: ["Aldéhyde", "Fève Tonka", "Cèdre", "Absolu d'Iris", "Jasmin Sambac", "Amande"],
    personality: ["vert", "précieux", "floral", "sophistiqué"],
    mood: ["sophistiqué", "élégant", "frais"]
  },
  {
    id: 29,
    name: "GREEN MALACHITE",
    category: "Vert",
    description: "La malachite verte dans cette composition où la bigarade rencontre l'ylang-ylang et la vanille.",
    notes: ["Bigarade", "Petit-grain", "Jasmin Sambac", "Ylang-ylang", "Vanille"],
    personality: ["vert", "minéral", "floral", "exotique"],
    mood: ["frais", "exotique", "harmonieux"]
  },
  {
    id: 30,
    name: "GREEN NIGHT",
    category: "Vert",
    description: "La nuit verte dans cette composition où la fleur d'oranger rencontre l'ambre et les notes boisées.",
    notes: ["Fleur d'Oranger", "Ambre", "Notes Boisées"],
    personality: ["vert", "nocturne", "floral", "boisé"],
    mood: ["mystérieux", "paisible", "harmonieux"]
  },
  {
    id: 31,
    name: "GREY",
    category: "Neutre",
    description: "Le gris élégant dans cette composition où la bergamote rencontre la rose et l'ambre.",
    notes: ["Bergamote", "Pamplemousse", "Rose", "Santal", "Ambre"],
    personality: ["neutre", "élégant", "équilibré", "moderne"],
    mood: ["élégant", "équilibré", "sophistiqué"]
  },
  {
    id: 32,
    name: "IMAGINE",
    category: "Frais",
    description: "Imaginez cette fraîcheur où la bergamote rencontre le gingembre et l'ambroxan.",
    notes: ["Bergamote", "Gingembre", "Neroli", "Ambroxan"],
    personality: ["frais", "imaginatif", "moderne", "épicé"],
    mood: ["frais", "énergique", "optimiste"]
  },
  {
    id: 33,
    name: "ISPAHAN",
    category: "Oriental",
    description: "Ispahan, la ville des roses, dans cette composition où la rose rencontre l'oud et le cèdre.",
    notes: ["Rose", "Ciste", "Patchouli", "Santal", "Oud", "Cèdre"],
    personality: ["oriental", "floral", "précieux", "mystique"],
    mood: ["mystérieux", "romantique", "sophistiqué"]
  },
  {
    id: 34,
    name: "KALEEMAT",
    category: "Fruité",
    description: "Kaleemat, où la myrtille rencontre l'anis dans une composition musquée et miellée.",
    notes: ["Myrtille", "Anis", "Bois de Cachemire", "Ambre", "Miel", "Musc"],
    personality: ["fruité", "épicé", "doux", "chaleureux"],
    mood: ["gourmand", "chaleureux", "réconfortant"]
  },
  {
    id: 35,
    name: "KING OF THE POP",
    category: "Gourmand",
    description: "Le roi du pop-corn dans cette composition gourmande où le caramel rencontre la vanille.",
    notes: ["Pop Corn", "Caramel", "Vanille", "Musc"],
    personality: ["gourmand", "amusant", "moderne", "sucré"],
    mood: ["amusant", "gourmand", "nostalgique"]
  },
  {
    id: 36,
    name: "KIRKE",
    category: "Fruité",
    description: "Kirke, la magicienne, dans cette composition où le fruit de la passion rencontre la vanille.",
    notes: ["Fruit de la Passion", "Poire", "Framboise", "Musc", "Vanille", "Bois de Santal"],
    personality: ["fruité", "magique", "sensuel", "féminin"],
    mood: ["sensuel", "fruité", "mystérieux"]
  },
  {
    id: 37,
    name: "KISS",
    category: "Floral",
    description: "Un baiser floral où la pêche rencontre le jasmin et la vanille dans une harmonie tendre.",
    notes: ["Pêche", "Jasmin", "Vanille", "Bois de Santal"],
    personality: ["tendre", "floral", "fruité", "romantique"],
    mood: ["romantique", "tendre", "doux"]
  },
  {
    id: 38,
    name: "L'AFTER",
    category: "Agrumes",
    description: "L'après-midi parfait avec cette composition d'agrumes où la mandarine rencontre l'ambre gris.",
    notes: ["Mandarine", "Orange", "Ambre Gris", "Gingembre"],
    personality: ["agrumes", "énergique", "moderne", "pétillant"],
    mood: ["énergique", "optimiste", "pétillant"]
  },
  {
    id: 39,
    name: "L'ESCAPADE",
    category: "Gourmand",
    description: "L'escapade gourmande où la canne à sucre rencontre la vanille et les fèves.",
    notes: ["Canne à Sucre", "Vanille", "Fève", "Musc"],
    personality: ["gourmand", "aventurier", "sucré", "libre"],
    mood: ["libre", "gourmand", "aventurier"]
  },
  {
    id: 40,
    name: "L'INTERDIT",
    category: "Floral",
    description: "L'interdit floral où la poire rencontre la tubéreuse dans une composition audacieuse.",
    notes: ["Poire", "Bergamote", "Tubéreuse", "Fleur d'Oranger", "Patchouli"],
    personality: ["interdit", "audacieux", "floral", "mystérieux"],
    mood: ["audacieux", "mystérieux", "séduisant"]
  },
  {
    id: 41,
    name: "LA GUIMAUVE",
    category: "Gourmand",
    description: "La guimauve dans cette composition gourmande où le neroli rencontre le jasmin et le caramel.",
    notes: ["Neroli", "Jasmin", "Sucre", "Vanille", "Caramel", "Civette"],
    personality: ["gourmand", "doux", "floral", "enfantin"],
    mood: ["gourmand", "nostalgique", "doux"]
  },
  {
    id: 42,
    name: "LA NOTA",
    category: "Fruité",
    description: "La note parfaite dans cette composition fruitée où le caramel rencontre l'ananas.",
    notes: ["Caramel", "Ananas", "Noix de Coco", "Framboise", "Musc"],
    personality: ["fruité", "tropical", "gourmand", "joyeux"],
    mood: ["joyeux", "tropical", "gourmand"]
  },
  {
    id: 43,
    name: "LOST",
    category: "Fruité",
    description: "Perdu dans cette composition fruitée où la griotte rencontre la cerise noire et l'amande.",
    notes: ["Griotte", "Prune", "Rose de Turquie", "Cerise Noire", "Cherry Liqueur", "Amande"],
    personality: ["fruité", "perdu", "mystérieux", "gourmand"],
    mood: ["mystérieux", "gourmand", "nostalgique"]
  },
  {
    id: 44,
    name: "MADAWI",
    category: "Floral",
    description: "Madawi, où la pêche rencontre les fleurs dans une composition florale et musquée.",
    notes: ["Pêche", "Fleur de Pommier", "Fleur d'Ananas", "Musc", "Rose Sauvage"],
    personality: ["floral", "fruité", "doux", "sauvage"],
    mood: ["doux", "floral", "sauvage"]
  },
  {
    id: 45,
    name: "MALIKI OUD",
    category: "Oud",
    description: "Maliki Oud, le roi de l'oud, dans cette composition où la lavande rencontre le tabac.",
    notes: ["Pamplemousse", "Lavande", "Tabac", "Épices", "Oud", "Notes Boisées Sombres"],
    personality: ["oud", "royal", "sombre", "épicé"],
    mood: ["mystérieux", "puissant", "sophistiqué"]
  },
  {
    id: 46,
    name: "NOMADE",
    category: "Boisé",
    description: "Le nomade dans cette composition boisée où l'agar rencontre l'encens et la framboise.",
    notes: ["Bois d'Agar", "Larmes de Résine", "Encens", "Framboise"],
    personality: ["nomade", "boisé", "mystique", "libre"],
    mood: ["libre", "mystique", "aventurier"]
  },
  {
    id: 47,
    name: "NOUVEAU MONDE",
    category: "Oriental",
    description: "Le nouveau monde dans cette composition orientale où l'oud rencontre le cacao et le safran.",
    notes: ["Oud", "Cuir", "Cacao", "Safran", "Rose", "Amber Wood"],
    personality: ["nouveau", "oriental", "aventurier", "mystique"],
    mood: ["aventurier", "mystique", "audacieux"]
  },
  {
    id: 48,
    name: "OCEAN VIKING",
    category: "Aquatique",
    description: "Le viking des océans dans cette composition aquatique où le poivre rencontre l'absinthe.",
    notes: ["Poivre", "Absinthe", "Vetiver", "Musc Blanc"],
    personality: ["aquatique", "viking", "fort", "marin"],
    mood: ["puissant", "frais", "audacieux"]
  },
  {
    id: 49,
    name: "OUD ITS WOOD",
    category: "Oud",
    description: "L'oud, c'est du bois, dans cette composition où l'oud rencontre le santal et le vétiver.",
    notes: ["Bois de Oud", "Bois de Santal", "Vétiver", "Fève de Tonka", "Vanille"],
    personality: ["oud", "boisé", "authentique", "terreux"],
    mood: ["ancré", "mystérieux", "authentique"]
  },
  {
    id: 50,
    name: "OUD JAUNE",
    category: "Oud",
    description: "L'oud jaune dans cette composition tropicale où le tiaré rencontre l'ananas et le jasmin.",
    notes: ["Tiaré Tahiti", "Notes Fruitées", "Ananas", "Jasmin", "Fleurs Blanches", "Oud"],
    personality: ["oud", "tropical", "jaune", "exotique"],
    mood: ["tropical", "exotique", "mystérieux"]
  },
  {
    id: 51,
    name: "OUD ORANGE",
    category: "Oud",
    description: "L'oud orange dans cette composition fruitée où la noix de coco rencontre la vanille bourbon.",
    notes: ["Notes Fruitées", "Noix de Coco", "Vanille Bourbon", "Vanille", "Musc"],
    personality: ["oud", "fruité", "tropical", "gourmand"],
    mood: ["tropical", "gourmand", "mystérieux"]
  },
  {
    id: 52,
    name: "PANAKO SAMUI",
    category: "Tropical",
    description: "Panako Samui, l'île tropicale, dans cette composition où la mangue rencontre le safran.",
    notes: ["Mangue", "Orange", "Vanille", "Safran", "Tonka"],
    personality: ["tropical", "exotique", "île", "épicé"],
    mood: ["tropical", "exotique", "relaxant"]
  },
  {
    id: 53,
    name: "PEGAZ",
    category: "Aromatique",
    description: "Pégase dans cette composition aromatique où l'héliotrope rencontre l'amande amère.",
    notes: ["Héliotrope", "Cumin", "Amande Amère", "Lavande", "Vanille", "Bois de Santal"],
    personality: ["aromatique", "mythique", "épicé", "complexe"],
    mood: ["mystique", "complexe", "sophisticated"]
  },
  {
    id: 54,
    name: "PINK SUGAR",
    category: "Gourmand",
    description: "Le sucre rose dans cette composition gourmande où la framboise rencontre les fruits rouges.",
    notes: ["Fèves de Tonka", "Bois de Santal", "Notes Fruits Rouges", "Bergamote", "Framboise"],
    personality: ["gourmand", "rose", "sucré", "fruité"],
    mood: ["gourmand", "joyeux", "romantique"]
  },
  {
    id: 55,
    name: "RED CHRONIC",
    category: "Fruité",
    description: "Red Chronic, la chronique rouge, dans cette composition où la crème fouettée rencontre le melon.",
    notes: ["Crème Fouettée", "Melon", "Poire", "Framboise", "Cannelle", "Musc Blanc", "Patchouli"],
    personality: ["rouge", "fruité", "gourmand", "épicé"],
    mood: ["gourmand", "énergique", "audacieux"]
  },
  {
    id: 56,
    name: "RED SMOKING",
    category: "Fruité",
    description: "Red Smoking, la cerise fumée, dans cette composition où la vanille rencontre l'ambroxan.",
    notes: ["Cerise", "Vanille", "Ambroxan", "Fève"],
    personality: ["rouge", "fumé", "fruité", "mystérieux"],
    mood: ["mystérieux", "sensuel", "audacieux"]
  },
  {
    id: 57,
    name: "REDMULA",
    category: "Fruité",
    description: "Redmula, la formule rouge, dans cette composition où la fraise rencontre l'oud.",
    notes: ["Fraise", "Cerise", "Caramel", "Gingembre", "Oud", "Vanille", "Patchouli"],
    personality: ["rouge", "fruité", "oriental", "épicé"],
    mood: ["audacieux", "gourmand", "mystérieux"]
  },
  {
    id: 58,
    name: "ROSE N OUD",
    category: "Floral Oriental",
    description: "Rose et Oud dans cette composition où le clou de girofle rencontre la rose de Damas.",
    notes: ["Clou de Girofle", "Rose de Damas", "Bois de Oud"],
    personality: ["floral", "oriental", "épicé", "précieux"],
    mood: ["romantique", "mystérieux", "sophistiqué"]
  },
  {
    id: 59,
    name: "ROSE VANILLA",
    category: "Floral Gourmand",
    description: "Rose Vanilla, l'alliance parfaite, dans cette composition où la rose de Turquie rencontre la vanille.",
    notes: ["Citron d'Italie", "Rose de Turquie", "Vanille", "Musc Blanc", "Cèdre"],
    personality: ["floral", "gourmand", "romantique", "équilibré"],
    mood: ["romantique", "gourmand", "harmonieux"]
  },
  {
    id: 60,
    name: "ROSENDO 8",
    category: "Fruité",
    description: "Rosendo 8, la huitième rose, dans cette composition où l'ananas rencontre la cannelle.",
    notes: ["Ananas", "Pomme", "Cannelle", "Vanille", "Vetiver"],
    personality: ["fruité", "épicé", "moderne", "complexe"],
    mood: ["énergique", "moderne", "épicé"]
  },
  {
    id: 61,
    name: "ROSENDO CINCO",
    category: "Floral",
    description: "Rosendo Cinco, la cinquième rose, dans cette composition où le jasmin rencontre le muguet.",
    notes: ["Jasmin", "Muguet", "Caramel", "Ambre", "Cuir", "Musc"],
    personality: ["floral", "complexe", "sophistiqué", "cuir"],
    mood: ["sophistiqué", "élégant", "mystérieux"]
  },
  {
    id: 62,
    name: "SABLE ROSE",
    category: "Floral Oriental",
    description: "Sable Rose, le sable rosé, dans cette composition où la rose rencontre l'oud et le safran.",
    notes: ["Rose", "Bois de Oud", "Ambre Gris", "Poivre Noir", "Safran"],
    personality: ["floral", "oriental", "épicé", "mystérieux"],
    mood: ["mystérieux", "sophistiqué", "sensuel"]
  },
  {
    id: 63,
    name: "SO MULA",
    category: "Gourmand",
    description: "So Mula, la formule parfaite, dans cette composition où le caramel rencontre l'oud.",
    notes: ["Caramel", "Fruits Rouges", "Vanille", "Oud", "Benjoin"],
    personality: ["gourmand", "oriental", "fruité", "mystique"],
    mood: ["gourmand", "mystérieux", "réconfortant"]
  },
  {
    id: 64,
    name: "SO VELORUM",
    category: "Floral Oriental",
    description: "So Velorum, le voile mystique, dans cette composition où la rose de Damas rencontre l'oud.",
    notes: ["Clou de Girofle", "Rose de Damas", "Bois de Oud"],
    personality: ["mystique", "floral", "oriental", "épicé"],
    mood: ["mystérieux", "sophistiqué", "élégant"]
  },
  {
    id: 65,
    name: "SOLID",
    category: "Floral",
    description: "Solid, la solidité florale, dans cette composition où la pêche rencontre la fleur d'oranger.",
    notes: ["Pêche", "Mandarine", "Fleur d'Oranger", "Rose", "Bois de Santal", "Praliné", "Vanille"],
    personality: ["solid", "floral", "fruité", "gourmand"],
    mood: ["stable", "gourmand", "harmonieux"]
  },
  {
    id: 66,
    name: "SUNRISE",
    category: "Floral",
    description: "Sunrise, le lever du soleil, dans cette composition où la framboise rencontre le jasmin.",
    notes: ["Framboise", "Mandarine", "Jasmin", "Gingembre"],
    personality: ["floral", "fruité", "matinal", "épicé"],
    mood: ["énergique", "optimiste", "frais"]
  },
  {
    id: 67,
    name: "SUNSHINE",
    category: "Solaire",
    description: "Sunshine, le soleil brillant, dans cette composition où la bergamote rencontre la fleur d'oranger.",
    notes: ["Bigarade", "Bergamote", "Petitgrain", "Fleur d'Oranger", "Jasmin", "Vanille"],
    personality: ["solaire", "lumineux", "floral", "gourmand"],
    mood: ["ensoleillé", "joyeux", "optimiste"]
  },
  {
    id: 68,
    name: "SUPREME",
    category: "Floral",
    description: "Supreme, la suprématie florale, dans cette composition où la tubéreuse rencontre l'ylang-ylang.",
    notes: ["Notes Fruitées", "Poire", "Tubéreuse", "Ylang-ylang", "Ambre", "Patchouli"],
    personality: ["suprême", "floral", "fruité", "luxueux"],
    mood: ["luxueux", "sophistiqué", "élégant"]
  },
  {
    id: 69,
    name: "THE CASHMERE",
    category: "Luxe",
    description: "The Cashmere, la douceur du cachemire, dans cette composition où la lavande rencontre le tabac.",
    notes: ["Pamplemousse", "Lavande", "Tabac", "Épices", "Oud", "Notes Boisées Sombres"],
    personality: ["luxueux", "doux", "épicé", "mystérieux"],
    mood: ["luxueux", "réconfortant", "sophistiqué"]
  },
  {
    id: 70,
    name: "THE TOBACCO",
    category: "Tabac",
    description: "The Tobacco, l'essence du tabac, dans cette composition où les épices rencontrent le cacao.",
    notes: ["Feuille de Tabac", "Notes Épicées", "Vanille", "Cacao", "Notes Boisées"],
    personality: ["tabac", "épicé", "gourmand", "masculin"],
    mood: ["sophistiqué", "mystérieux", "réconfortant"]
  },
  {
    id: 71,
    name: "TONKA",
    category: "Gourmand",
    description: "Tonka, la fève magique, dans cette composition où la myrtille rencontre l'anis.",
    notes: ["Myrtille", "Anis", "Bois de Cachemire", "Ambre", "Miel", "Musc"],
    personality: ["gourmand", "fruité", "épicé", "doux"],
    mood: ["gourmand", "réconfortant", "chaleureux"]
  },
  {
    id: 72,
    name: "TRAFALGAR",
    category: "Fruité",
    description: "Trafalgar, la bataille des fruits, dans cette composition où la framboise rencontre la fraise.",
    notes: ["Framboise", "Fraise", "Cerise", "Cassis", "Musc", "Patchouli"],
    personality: ["fruité", "bataille", "intense", "vibrant"],
    mood: ["énergique", "audacieux", "vibrant"]
  },
  {
    id: 73,
    name: "TWILIGHT",
    category: "Floral",
    description: "Twilight, le crépuscule, dans cette composition où le gingembre rencontre la fleur d'oranger.",
    notes: ["Gingembre", "Fleur d'Oranger", "Jasmin", "Vanille"],
    personality: ["crépusculaire", "floral", "épicé", "mystérieux"],
    mood: ["mystérieux", "romantique", "paisible"]
  },
  {
    id: 74,
    name: "VENOM",
    category: "Gourmand",
    description: "Venom, le venin sucré, dans cette composition où le caramel rencontre la barbe à papa.",
    notes: ["Caramel", "Prune", "Barbe à Papa", "Résine d'Oliban"],
    personality: ["venimeux", "gourmand", "mystérieux", "dangereux"],
    mood: ["mystérieux", "gourmand", "séduisant"]
  },
  {
    id: 75,
    name: "WHITE MUSC",
    category: "Musc",
    description: "White Musc, le musc blanc, dans cette composition où la muscade rencontre le jasmin.",
    notes: ["Noix de Muscade", "Baie Rose", "Jasmin", "Cèdre", "Patchouli", "Santal"],
    personality: ["musc", "blanc", "pur", "boisé"],
    mood: ["pur", "paisible", "harmonieux"]
  },
  {
    id: 76,
    name: "ZAK LATTE",
    category: "Gourmand",
    description: "Zak Latte, le latte parfait, dans cette composition où le caramel rencontre le miel.",
    notes: ["Caramel", "Miel", "Vanille", "Musc"],
    personality: ["gourmand", "café", "doux", "réconfortant"],
    mood: ["réconfortant", "gourmand", "chaleureux"]
  },
  {
    id: 77,
    name: "BELLE BETE",
    category: "Contraste",
    description: "Belle Bête, la beauté et la bête, dans cette composition où le lait rencontre l'ambrette.",
    notes: ["Lait", "Ambrette", "Vanille", "Musc"],
    personality: ["contraste", "doux", "mystérieux", "féminin"],
    mood: ["mystérieux", "doux", "sensuel"]
  },
  {
    id: 78,
    name: "RED BOND",
    category: "Fruité",
    description: "Red Bond, le lien rouge, dans cette composition où la mandarine rencontre la framboise.",
    notes: ["Mandarine", "Framboise", "Rose", "Caramel", "Vanille"],
    personality: ["rouge", "fruité", "lien", "romantique"],
    mood: ["romantique", "gourmand", "énergique"]
  },
  {
    id: 79,
    name: "VANILLA 2.0",
    category: "Vanille",
    description: "Vanilla 2.0, la vanille du futur, dans cette composition où l'amande rencontre la fève de tonka.",
    notes: ["Amande", "Vanille", "Tonka", "Bois de Santal"],
    personality: ["vanille", "moderne", "futuriste", "gourmand"],
    mood: ["moderne", "gourmand", "réconfortant"]
  },
  {
    id: 80,
    name: "THE POWDER",
    category: "Poudré",
    description: "The Powder, la poudre ultime, dans cette composition où la noix de coco rencontre le musc blanc.",
    notes: ["Coconut", "Vanille", "Musc Blanc", "Noix de Coco"],
    personality: ["poudré", "doux", "tropical", "pur"],
    mood: ["doux", "pur", "tropical"]
  },
  {
    id: 81,
    name: "KEELA",
    category: "Fruité",
    description: "Keela, la joie fruitée, dans cette composition où la banane rencontre la fraise.",
    notes: ["Banane", "Fraise", "Pistache", "Vanille", "Caramel"],
    personality: ["fruité", "joyeux", "gourmand", "tropical"],
    mood: ["joyeux", "gourmand", "tropical"]
  },
  {
    id: 82,
    name: "ZUMO",
    category: "Épicé",
    description: "Zumo, le jus épicé, dans cette composition où la cardamome rencontre la vanille.",
    notes: ["Cardamome", "Vanille", "Musc"],
    personality: ["épicé", "simple", "moderne", "doux"],
    mood: ["épicé", "moderne", "réconfortant"]
  },
  {
    id: 83,
    name: "DALACHAI",
    category: "Épicé",
    description: "Dalachai, le thé épicé, dans cette composition où le fruit de la passion rencontre le café.",
    notes: ["Fruit de la passion", "Cardamome", "Safran", "Café", "Lait"],
    personality: ["épicé", "exotique", "énergique", "réconfortant"],
    mood: ["énergique", "exotique", "réconfortant"]
  },
  {
    id: 84,
    name: "PARIS LA NUIT",
    category: "Nocturne",
    description: "Paris la Nuit, la ville lumière nocturne, dans cette composition où le gingembre rencontre la mandarine.",
    notes: ["Gingembre", "Mandarine", "Fleur d'oranger", "Patchouli"],
    personality: ["nocturne", "parisien", "sophistiqué", "mystérieux"],
    mood: ["mystérieux", "sophistiqué", "urbain"]
  },
  {
    id: 85,
    name: "OUD CHERRY",
    category: "Oud",
    description: "Oud Cherry, la cerise orientale, dans cette composition où la cerise rencontre l'oud.",
    notes: ["Cerise", "Rose", "Oud", "Cuir"],
    personality: ["oud", "fruité", "oriental", "cuir"],
    mood: ["mystérieux", "fruité", "sophistiqué"]
  },
  {
    id: 86,
    name: "LE CHARNEL",
    category: "Sensuel",
    description: "Le Charnel, la sensualité incarnée, dans cette composition où la cardamome rencontre l'iris.",
    notes: ["Cardamome", "Figue", "Iris", "Bois de Santal", "Tonka"],
    personality: ["sensuel", "charnel", "sophistiqué", "mystérieux"],
    mood: ["sensuel", "mystérieux", "sophistiqué"]
  },
  {
    id: 87,
    name: "PARISAN DREAM",
    category: "Rêve",
    description: "Parisan Dream, le rêve parisien, dans cette composition où l'amyris rencontre l'ambroxan.",
    notes: ["Amyris", "Ambroxan", "Santal", "Vanille"],
    personality: ["rêveur", "parisien", "moderne", "sophistiqué"],
    mood: ["rêveur", "sophistiqué", "moderne"]
  },
  {
    id: 88,
    name: "GIRL OR BOY",
    category: "Unisexe",
    description: "Girl or Boy, au-delà des genres, dans cette composition unisexe où l'osmanthus rencontre le cuir.",
    notes: ["Osmanthus", "Cuir"],
    personality: ["unisexe", "moderne", "libre", "cuir"],
    mood: ["libre", "moderne", "audacieux"]
  }
];

// Questions du quiz améliorées pour une expérience plus agréable et pertinente
export const quizQuestions = [
  {
    id: 1,
    question: "Quel moment de la journée correspond le mieux à votre énergie ?",
    type: "energy",
    options: [
      { value: "dawn", label: "L'aube - Fraîcheur et renouveau", personality: ["frais", "optimiste", "énergique"], mood: ["énergique", "optimiste", "frais"] },
      { value: "morning", label: "Le matin - Dynamisme et clarté", personality: ["énergique", "confiant", "moderne"], mood: ["confiant", "énergique", "moderne"] },
      { value: "afternoon", label: "L'après-midi - Chaleur et luminosité", personality: ["chaleureux", "lumineux", "joyeux"], mood: ["joyeux", "ensoleillé", "optimiste"] },
      { value: "evening", label: "Le soir - Sophistication et mystère", personality: ["sophistiqué", "mystérieux", "élégant"], mood: ["sophistiqué", "mystérieux", "élégant"] },
      { value: "night", label: "La nuit - Intimité et profondeur", personality: ["mystique", "sensuel", "profond"], mood: ["mystérieux", "sensuel", "intime"] }
    ]
  },
  {
    id: 2,
    question: "Quelle saveur vous fait le plus saliver ?",
    type: "taste",
    options: [
      { value: "sweet", label: "Sucré - Caramel, vanille, miel", personality: ["gourmand", "doux", "réconfortant"], mood: ["gourmand", "réconfortant", "doux"] },
      { value: "spicy", label: "Épicé - Cannelle, poivre, gingembre", personality: ["épicé", "audacieux", "chaleureux"], mood: ["audacieux", "énergique", "chaleureux"] },
      { value: "fresh", label: "Frais - Agrumes, menthe, eucalyptus", personality: ["frais", "énergique", "moderne"], mood: ["frais", "énergique", "optimiste"] },
      { value: "floral", label: "Floral - Rose, jasmin, pivoine", personality: ["floral", "romantique", "délicat"], mood: ["romantique", "paisible", "harmonieux"] },
      { value: "woody", label: "Boisé - Santal, cèdre, patchouli", personality: ["boisé", "sophistiqué", "ancré"], mood: ["paisible", "sophistiqué", "ancré"] }
    ]
  },
  {
    id: 3,
    question: "Quelle destination vous fait rêver en ce moment ?",
    type: "destination",
    options: [
      { value: "tropical", label: "Île tropicale - Cocotiers et lagons", personality: ["tropical", "libre", "exotique"], mood: ["relaxant", "tropical", "joyeux"] },
      { value: "oriental", label: "Palais oriental - Marrakech, Istanbul", personality: ["oriental", "mystique", "luxueux"], mood: ["mystérieux", "luxueux", "sophistiqué"] },
      { value: "parisian", label: "Paris romantique - Cafés et jardins", personality: ["parisien", "romantique", "élégant"], mood: ["romantique", "sophistiqué", "urbain"] },
      { value: "nature", label: "Forêt enchantée - Verdure et sérénité", personality: ["naturel", "paisible", "boisé"], mood: ["paisible", "naturel", "harmonieux"] },
      { value: "modern", label: "Ville moderne - Gratte-ciels et innovation", personality: ["moderne", "énergique", "urbain"], mood: ["moderne", "énergique", "confiant"] }
    ]
  },
  {
    id: 4,
    question: "Quel type de musique vous transporte le plus ?",
    type: "music",
    options: [
      { value: "classical", label: "Classique - Symphonies et opéras", personality: ["raffiné", "sophistiqué", "élégant"], mood: ["sophistiqué", "paisible", "élégant"] },
      { value: "jazz", label: "Jazz - Improvisation et sensualité", personality: ["sophistiqué", "mystérieux", "sensuel"], mood: ["mystérieux", "sensuel", "sophistiqué"] },
      { value: "pop", label: "Pop - Mélodies entraînantes", personality: ["joyeux", "moderne", "énergique"], mood: ["joyeux", "énergique", "optimiste"] },
      { value: "world", label: "Musique du monde - Découvertes exotiques", personality: ["exotique", "aventurier", "oriental"], mood: ["exotique", "aventurier", "mystérieux"] },
      { value: "electronic", label: "Électronique - Sonorités futuristes", personality: ["moderne", "mystique", "audacieux"], mood: ["moderne", "audacieux", "énergique"] }
    ]
  },
  {
    id: 5,
    question: "Quelle texture vous attire le plus ?",
    type: "texture",
    options: [
      { value: "velvet", label: "Velours - Douceur luxueuse", personality: ["luxueux", "sensuel", "doux"], mood: ["luxueux", "sensuel", "réconfortant"] },
      { value: "silk", label: "Soie - Élégance raffinée", personality: ["élégant", "sophistiqué", "précieux"], mood: ["sophistiqué", "élégant", "harmonieux"] },
      { value: "cashmere", label: "Cachemire - Confort absolu", personality: ["doux", "réconfortant", "chaleureux"], mood: ["réconfortant", "chaleureux", "paisible"] },
      { value: "leather", label: "Cuir - Caractère affirmé", personality: ["audacieux", "fort", "mystérieux"], mood: ["audacieux", "confiant", "mystérieux"] },
      { value: "cotton", label: "Coton - Simplicité naturelle", personality: ["naturel", "simple", "frais"], mood: ["frais", "naturel", "paisible"] }
    ]
  },
  {
    id: 6,
    question: "Quel parfum gourmand vous fait le plus envie ?",
    type: "gourmand",
    options: [
      { value: "vanilla", label: "Vanille crémeuse", personality: ["gourmand", "doux", "réconfortant"], mood: ["gourmand", "réconfortant", "doux"] },
      { value: "chocolate", label: "Chocolat noir intense", personality: ["gourmand", "mystérieux", "sensuel"], mood: ["sensuel", "mystérieux", "gourmand"] },
      { value: "caramel", label: "Caramel au beurre salé", personality: ["gourmand", "chaleureux", "séduisant"], mood: ["gourmand", "chaleureux", "séduisant"] },
      { value: "coffee", label: "Café fraîchement torréfié", personality: ["énergique", "moderne", "audacieux"], mood: ["énergique", "moderne", "audacieux"] },
      { value: "honey", label: "Miel doré", personality: ["gourmand", "naturel", "chaleureux"], mood: ["gourmand", "chaleureux", "naturel"] }
    ]
  },
  {
    id: 7,
    question: "Quelle ambiance vous correspond le mieux ?",
    type: "ambiance",
    options: [
      { value: "romantic", label: "Romantique - Dîner aux chandelles", personality: ["romantique", "sensuel", "élégant"], mood: ["romantique", "sensuel", "intime"] },
      { value: "adventurous", label: "Aventurier - Exploration et découverte", personality: ["aventurier", "libre", "audacieux"], mood: ["aventurier", "libre", "audacieux"] },
      { value: "sophisticated", label: "Sophistiqué - Galerie d'art privée", personality: ["sophistiqué", "raffiné", "élégant"], mood: ["sophistiqué", "élégant", "cultivé"] },
      { value: "peaceful", label: "Paisible - Méditation dans la nature", personality: ["paisible", "naturel", "harmonieux"], mood: ["paisible", "harmonieux", "ancré"] },
      { value: "energetic", label: "Énergique - Fête entre amis", personality: ["énergique", "joyeux", "social"], mood: ["énergique", "joyeux", "social"] }
    ]
  },
  {
    id: 8,
    question: "Quel élément naturel vous inspire le plus ?",
    type: "element",
    options: [
      { value: "fire", label: "Feu - Passion et énergie", personality: ["passionné", "énergique", "audacieux"], mood: ["passionné", "énergique", "audacieux"] },
      { value: "water", label: "Eau - Fluidité et sérénité", personality: ["fluide", "paisible", "mystérieux"], mood: ["paisible", "mystérieux", "harmonieux"] },
      { value: "earth", label: "Terre - Stabilité et authenticité", personality: ["authentique", "stable", "naturel"], mood: ["ancré", "naturel", "stable"] },
      { value: "air", label: "Air - Liberté et légèreté", personality: ["libre", "léger", "frais"], mood: ["libre", "frais", "optimiste"] },
      { value: "wood", label: "Bois - Sagesse et profondeur", personality: ["sage", "profond", "boisé"], mood: ["sophistiqué", "ancré", "mystérieux"] }
    ]
  }
];

// Algorithme de matching amélioré pour des recommandations plus précises
export const calculatePerfumeMatch = (answers) => {
  const personalityScores = {};
  const moodScores = {};
  const categoryPreferences = {};
  
  // Calculer les scores de personnalité, d'humeur et de catégories basés sur les réponses
  answers.forEach(answer => {
    const question = quizQuestions.find(q => q.id === answer.questionId);
    const selectedOption = question.options.find(opt => opt.value === answer.value);
    
    // Pondération basée sur le type de question
    let weight = 1;
    if (question.type === 'taste' || question.type === 'gourmand') weight = 1.5; // Plus d'importance aux préférences gustatives
    if (question.type === 'ambiance' || question.type === 'energy') weight = 1.3; // Importance aux ambiances
    
    selectedOption.personality.forEach(trait => {
      personalityScores[trait] = (personalityScores[trait] || 0) + weight;
    });
    
    selectedOption.mood.forEach(moodTrait => {
      moodScores[moodTrait] = (moodScores[moodTrait] || 0) + weight;
    });
    
    // Déduire les préférences de catégories des réponses
    if (selectedOption.value === 'sweet' || selectedOption.value === 'vanilla' || selectedOption.value === 'chocolate') {
      categoryPreferences['Gourmand'] = (categoryPreferences['Gourmand'] || 0) + 2;
    }
    if (selectedOption.value === 'spicy' || selectedOption.value === 'oriental') {
      categoryPreferences['Oriental'] = (categoryPreferences['Oriental'] || 0) + 2;
      categoryPreferences['Épicé'] = (categoryPreferences['Épicé'] || 0) + 2;
    }
    if (selectedOption.value === 'floral' || selectedOption.value === 'romantic') {
      categoryPreferences['Floral'] = (categoryPreferences['Floral'] || 0) + 2;
      categoryPreferences['Floral Oriental'] = (categoryPreferences['Floral Oriental'] || 0) + 1.5;
    }
    if (selectedOption.value === 'woody' || selectedOption.value === 'nature' || selectedOption.value === 'wood') {
      categoryPreferences['Boisé'] = (categoryPreferences['Boisé'] || 0) + 2;
      categoryPreferences['Oud'] = (categoryPreferences['Oud'] || 0) + 1.5;
    }
    if (selectedOption.value === 'fresh' || selectedOption.value === 'morning' || selectedOption.value === 'air') {
      categoryPreferences['Frais'] = (categoryPreferences['Frais'] || 0) + 2;
      categoryPreferences['Agrumes'] = (categoryPreferences['Agrumes'] || 0) + 1.5;
    }
    if (selectedOption.value === 'tropical' || selectedOption.value === 'water') {
      categoryPreferences['Tropical'] = (categoryPreferences['Tropical'] || 0) + 2;
      categoryPreferences['Aquatique'] = (categoryPreferences['Aquatique'] || 0) + 1.5;
    }
    if (selectedOption.value === 'night' || selectedOption.value === 'evening' || selectedOption.value === 'mysterious') {
      categoryPreferences['Nocturne'] = (categoryPreferences['Nocturne'] || 0) + 2;
      categoryPreferences['Sombre'] = (categoryPreferences['Sombre'] || 0) + 1.5;
    }
    if (selectedOption.value === 'luxurious' || selectedOption.value === 'velvet' || selectedOption.value === 'sophisticated') {
      categoryPreferences['Luxe'] = (categoryPreferences['Luxe'] || 0) + 2;
      categoryPreferences['Ambre'] = (categoryPreferences['Ambre'] || 0) + 1.5;
    }
  });
  
  // Normaliser les scores pour éviter les biais
  const maxPersonalityScore = Math.max(...Object.values(personalityScores));
  const maxMoodScore = Math.max(...Object.values(moodScores));
  const maxCategoryScore = Math.max(...Object.values(categoryPreferences));
  
  // Évaluer chaque parfum avec un système de scoring plus sophistiqué
  const scoredPerfumes = perfumes.map(perfume => {
    let score = 0;
    let matchDetails = {
      personalityMatch: 0,
      moodMatch: 0,
      categoryMatch: 0,
      notesMatch: 0
    };
    
    // Score basé sur la personnalité (30% du score total)
    perfume.personality.forEach(trait => {
      if (personalityScores[trait]) {
        const normalizedScore = (personalityScores[trait] / maxPersonalityScore) * 3;
        score += normalizedScore;
        matchDetails.personalityMatch += normalizedScore;
      }
    });
    
    // Score basé sur l'humeur (30% du score total)
    perfume.mood.forEach(moodTrait => {
      if (moodScores[moodTrait]) {
        const normalizedScore = (moodScores[moodTrait] / maxMoodScore) * 3;
        score += normalizedScore;
        matchDetails.moodMatch += normalizedScore;
      }
    });
    
    // Score basé sur la catégorie (25% du score total)
    if (categoryPreferences[perfume.category]) {
      const normalizedScore = (categoryPreferences[perfume.category] / maxCategoryScore) * 2.5;
      score += normalizedScore;
      matchDetails.categoryMatch = normalizedScore;
    }
    
    // Score basé sur les notes spécifiques (15% du score total)
    const desiredNotes = ['Vanille', 'Rose', 'Oud', 'Ambre', 'Bergamote', 'Jasmin', 'Santal', 'Patchouli'];
    let notesScore = 0;
    perfume.notes.forEach(note => {
      if (desiredNotes.some(desiredNote => note.toLowerCase().includes(desiredNote.toLowerCase()))) {
        notesScore += 0.3;
      }
    });
    score += notesScore;
    matchDetails.notesMatch = notesScore;
    
    // Bonus pour la diversité des notes (éviter les parfums trop simples)
    if (perfume.notes.length >= 4) {
      score += 0.5;
    }
    
    // Bonus pour les parfums avec des descriptions engageantes
    if (perfume.description && perfume.description.length > 100) {
      score += 0.2;
    }
    
    return { 
      ...perfume, 
      score: Math.round(score * 100) / 100,
      matchDetails,
      matchPercentage: Math.min(Math.round((score / 10) * 100), 100)
    };
  });
  
  // Trier par score et ajouter une diversité dans les recommandations
  const sortedPerfumes = scoredPerfumes.sort((a, b) => b.score - a.score);
  
  // Sélectionner les 5 meilleurs en évitant trop de parfums de la même catégorie
  const recommendations = [];
  const usedCategories = new Set();
  
  for (const perfume of sortedPerfumes) {
    if (recommendations.length >= 5) break;
    
    // Toujours ajouter le premier (meilleur score)
    if (recommendations.length === 0) {
      recommendations.push(perfume);
      usedCategories.add(perfume.category);
      continue;
    }
    
    // Pour les autres, favoriser la diversité des catégories
    if (!usedCategories.has(perfume.category) || recommendations.length >= 3) {
      recommendations.push(perfume);
      usedCategories.add(perfume.category);
    }
  }
  
  // Si on n'a pas assez de recommandations, compléter avec les meilleurs scores
  while (recommendations.length < 3 && recommendations.length < sortedPerfumes.length) {
    const nextBest = sortedPerfumes.find(p => !recommendations.includes(p));
    if (nextBest) {
      recommendations.push(nextBest);
    } else {
      break;
    }
  }
  
  return recommendations.slice(0, 3);
};